(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["bm-homebrew-agency-app"] = factory();
	else
		root["bm-homebrew-agency-app"] = factory();
})(self, function() {
return 